var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app fade-in full-height",attrs:{"id":"app"}},[_c('main',{attrs:{"id":"wholeView"}},[_c('router-view',{key:_vm.$route.path})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }